import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LoginService } from '../login.service';
import { HelperService } from '../../../auxiliares/servicios/helper.service';
import { LoadingService } from '../../../auxiliares/servicios/loading.service';
import { Router } from '@angular/router';
import { DialogService } from '../../../auxiliares/dialog/dialog.service';
import { EnvService } from '../../../env';

@Component({
  standalone: false,
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss',
})
export class ForgotPasswordComponent implements OnInit {
  private login = inject(LoginService);
  helper = inject(HelperService);
  loading = inject(LoadingService);
  private router = inject(Router);
  private dialogService = inject(DialogService);
  envService = inject(EnvService);

  public form?: FormGroup;
  public emailSent = false;

  private buildForm() {
    this.form = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
    });
  }

  public async onSubmit() {
    if (!this.form?.valid) {
      return;
    }

    this.loading.setLoading(true);
    try {
      const res = await this.dialogService.confirm(
        'Enviar email de recuperación',
        `¿Confirmás que querés enviar el email de recuperación de contraseña a ${this.form.get('email').value}?`,
        'Confirmar',
        'Cancelar',
      );
      if (!res) {
        this.loading.setLoading(false);
        return;
      }
      const email = this.form?.get('email')?.value;
      await this.login.resetPassword(email);
      this.emailSent = true;
      // La API responde 204 exista o no el email (no delata qué direcciones están
      // registradas), así que el texto no puede afirmar que se envió.
      this.helper.notifSuccess(
        'Si el email está registrado, vas a recibir las instrucciones',
      );
    } catch (error: any) {
      console.error(error);
      if (error.error?.message) {
        this.helper.notifError(error.error.message);
      } else {
        this.helper.notifError('Error al enviar el email de recuperación');
      }
    }
    this.loading.setLoading(false);
  }

  public goBackToLogin() {
    this.router.navigateByUrl('/login');
  }

  ngOnInit(): void {
    this.buildForm();
  }
}
